const createUserMessage = (formikValues) => ({
  role: 'user',
  content: [
    ...(formikValues.Question?.trim()
      ? [
          {
            id: `question-${Date.now()}`,
            type: 'Message',
            value: formikValues.Question,
          },
        ]
      : []),
    ...(formikValues.images?.map((img, index) => ({
      id: `image-${index}-${Date.now()}`,
      type: 'Image',
      value: URL.createObjectURL(img.file),
    })) || []),
    ...(formikValues.files?.map((file, index) => ({
      id: `file-${index}-${Date.now()}`,
      type: 'Document',
      value: file.file.name,
      file: file.file,
    })) || []),
    ...(formikValues.audio
      ? [
          {
            id: `audio-${Date.now()}`,
            type: 'Audio',
            value: formikValues.audio.id,
          },
        ]
      : []),
  ],
});

const transformChatData = (data) => {
  if (!data.steps || !Array.isArray(data?.steps)) return { messages: [] };
  return {
    ...data,
    messages: [
      {
        id: 'single-response',
        order: 1,
        role: 'bot',
        timestamp: new Date().toISOString(),
        isError: false,
        stepId: data.botChatDetailId,
        workflowName: data?.workflowName,
        content: data?.steps.flatMap((step) => {
          switch (step.nodeType) {
            case 'Message':
              return [
                {
                  id: step.id,
                  type: 'Message',
                  value: `<p>${step.message}</p>`,
                  isError: step.isError,
                  stepId: data.botChatDetailId,
                },
              ];
            case 'Image':
              return [
                {
                  id: step.id,
                  type: 'Image',
                  value: step.imageUrl,
                  stepId: data.botChatDetailId,
                },
              ];
            case 'Video':
              return [
                {
                  id: step.id,
                  type: 'Video',
                  value: step.videoUrl,
                  stepId: data.botChatDetailId,
                },
              ];
            case 'Document':
              return [
                {
                  id: step.id,
                  type: 'Document',
                  value: step.documentUrl,
                  name: step.name,
                  stepId: data.botChatDetailId,
                },
              ];
            case 'Question':
              return {
                id: step.id,
                type: 'Question',
                value: step.questions || [],
                visited: false,
                stepId: data.botChatDetailId,
              };
            case 'Carousel':
              return {
                id: step.id,
                type: 'Carousel',
                value: step.carousel,
                stepId: data.botChatDetailId,
              };
            case 'Form':
              return {
                id: step.id,
                type: 'Form',
                value: step.form,
                stepId: data.botChatDetailId,
              };
            default:
              return [];
          }
        }),
      },
    ],
  };
};
const transformNewChatData = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) return { messages: [] };

  const mergedMessages = [];

  for (const chat of rows) {
    const isUser = !!chat.IsUserNotBot;

    const rawText =
      typeof chat?.NodeInfomation?.message === 'string'
        ? chat.NodeInfomation.message
        : typeof chat?.Text === 'string'
        ? chat.Text
        : '';

    if (isUser && rawText.trim() === '') {
      continue;
    }

    const lastMessage = mergedMessages[mergedMessages.length - 1];

    let value =
      chat.NodeInfomation?.message ??
      chat.NodeInfomation?.questions ??
      chat.NodeInfomation?.form ??
      chat.Text;

    if (
      chat.Type === 'Question' &&
      Array.isArray(chat.NodeInfomation?.questions)
    ) {
      value = chat.NodeInfomation.questions;
    }
    if (chat.Type === 'Form' && typeof chat.NodeInfomation?.form === 'object') {
      value = chat.NodeInfomation.form;
    }

    const newContent = {
      id: chat.ChatDetailId,
      type: chat.Type,
      value,
      isError: chat.Value === false,
      stepId: chat.ActiveNodeId,
      dateCreated: chat.DateCreated,
    };

    if (lastMessage && lastMessage.role === (isUser ? 'user' : 'bot')) {
      lastMessage.content.push(newContent);
    } else {
      mergedMessages.push({
        id: chat.ChatId,
        order: mergedMessages.length + 1,
        role: isUser ? 'user' : 'bot',
        timestamp: chat.DateCreated,
        isError: chat.Value === false,
        stepId: chat.ActiveNodeId,
        workflowName: chat.WorkflowName || '',
        content: [newContent],
      });
    }
  }

  const messages = mergedMessages.filter(
    (m) => Array.isArray(m.content) && m.content.length > 0
  );

  return { messages };
};

export { transformNewChatData, transformChatData, createUserMessage };
